import React, { Component } from 'react';

interface Props {
	title: React.ReactNode;
	highlightTitle: boolean;
	subTitle: React.ReactNode;
	children: React.ReactNode;
	styles: {
		segment: string | null;
		segmentTitle: string | null;
		segmentHighlightedTitle: string | null;
		segmentList: string | null;
	};
	createOptionProps?(option: React.ReactNode, index: number): Record<never, never>;
}

export default class SegmentedSelectSegment extends Component<Props> {
	static defaultProps = {
		title: null,
		highlightTitle: false,
		subTitle: null,
		styles: {
			segment: null,
			segmentTitle: null,
			segmentHighlightedTitle: null,
			segmentList: null,
		},
		createOptionProps: null,
	};

	render() {
		const { children, title, highlightTitle, subTitle, styles, createOptionProps } = this.props;

		if (createOptionProps === undefined) {
			return null;
		}

		return (
			<div className={styles.segment || ''}>
				{title !== null ? (
					<h4 className={highlightTitle ? styles.segmentHighlightedTitle || '' : styles.segmentTitle || ''}>{title}</h4>
				) : null}
				{subTitle}
				<ul className={styles.segmentList || ''}>
					{React.Children.toArray(children).map((option, index) =>
						React.cloneElement(option as React.ReactElement, createOptionProps(option, index))
					)}
				</ul>
			</div>
		);
	}
}
